export default __webpack_public_path__ + "static/media/616.5015cad6.png";